var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.35 34.4H26V22h-3.65ZM24 17.9q.8 0 1.35-.525t.55-1.325q0-.85-.55-1.4-.55-.55-1.35-.55-.85 0-1.375.525T22.1 16q0 .85.55 1.375T24 17.9Zm0 26.9q-4.3 0-8.075-1.65-3.775-1.65-6.6-4.475-2.825-2.825-4.475-6.6Q3.2 28.3 3.2 23.95q0-4.3 1.65-8.075 1.65-3.775 4.475-6.6 2.825-2.825 6.6-4.45Q19.7 3.2 24 3.2q4.3 0 8.1 1.625t6.625 4.45q2.825 2.825 4.45 6.625T44.8 24q0 4.3-1.625 8.075-1.625 3.775-4.45 6.575-2.825 2.8-6.625 4.475Q28.3 44.8 24 44.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.8c072712940661f3074448d1325e420c.svg";
export { ForwardRef as ReactComponent };